<template>
  <div id="TheUserAccount">
    <el-form ref="form" :model="form" label-width="80px">
      <div id="userplay">
        <el-form-item label="企业名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="合同编号">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="行业类型">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      </div>
      <div class="title">
        <p>新增用户电表</p>
        <div></div>
      </div>
      <div id="bottom-inp">
        <el-form-item label="选择设备">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="尖电价">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="告警金额">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="峰电价">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="用电类型">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="平电价">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="初始金额">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="谷电价">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <div id="bttn">
          <el-form-item>
            <el-button type="primary" @click="onSubmit">添加</el-button>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div class="table">
      <el-table height="220" :data="tableData" stripe style="width: 100%"  ref="multipleTable"
     >
        <el-table-column  prop="date" label="表号" >
        </el-table-column>
        <el-table-column prop="name" label="商铺号">
        </el-table-column>
        <el-table-column prop="address" label="累计购电金额"> </el-table-column>
           <el-table-column prop="name" label="购电次数" >
        </el-table-column>
         <el-table-column  prop="name" label="操作" >
           
             
          <template slot-scope="scope">
            <div class="cat">
           <Particulars></Particulars>
            <el-link id="dele"
              type="primary"
              @click.native.prevent="deleteRow(scope.$index, tableData)"
              size="small"
              :underline="false"
              >删除</el-link
            ></div>
          </template>
    
        
 
        </el-table-column>
      </el-table>
    </div>
   <el-button id="btn" type="primary">开户</el-button>
  </div>
</template>
<script>
import Particulars from './TheUserAccountcomponents/particulars';
export default {
  components: { Particulars },
  data() {
    return {
      form: {
        name: "",
      },
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        }, {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        }
      ],
    };
  },
  methods: {
    onSubmit() {
      console.log("submit!");
    },
deleteRow(index, rows) {
        rows.splice(index, 1);
      }
   
  },
};
</script>
<style scoped lang="less">
#TheUserAccount {
  width: 100%;

  #userplay {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding-right: 160rem;
    justify-content: space-between;
  }
  #bottom-inp {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding-right: 160rem;
    justify-content: space-between;
  }

}

.title {
  display: flex;
  margin-bottom: 20rem;
  p {
    font-size: 16rem;
    color: #999999;
  }
  div {
    .w(1068);
    .h(1);
    border: 1px dashed #999999;
    margin-top: 11rem;
    margin-left: 6rem;
  }
}
.cat{
  // .w(100);
  display: flex !important;
  margin-left: 76rem;

}#dele{
  margin-left: 22rem !important;
  margin-top: 0rem ;
}


</style>